import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Spinner = ({ mauto, small, xsmall, nomtop, className }) => (
  <div className={classNames('Spinner', className, { mauto, small, xsmall, nomtop })} />
);

Spinner.defaultProps = {
  mauto: false,
  small: false,
  xsmall: false,
  nomtop: false,
  className: null
};

Spinner.propTypes = {
  className: PropTypes.string,
  mauto: PropTypes.bool,
  small: PropTypes.bool,
  xsmall: PropTypes.bool,
  nomtop: PropTypes.bool
};

export default Spinner;
